export interface IPNSConnection {
id: string;
}
